import process from 'process';

const development: boolean = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

/**
 * Add a console error if not in development.
 */
export function error(message: string): void {
  if (!development) {
    return;
  }

  console.error(`[FF error]: ${message}`);
}

/**
 * Add a console warning if not in development.
 */
export function warn(message: string): void {
  if (!development) {
    return;
  }

  console.warn(`[FF warn]: ${message}`);
}
